var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQrCodeLogo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 36.977c-8.368 0-12.551 0-15.15-2.599C0 31.778 0 27.595 0 19.228v-1.48c0-8.366 0-12.55 2.6-15.15C5.198 0 9.381 0 17.75 0h1.478c8.367 0 12.551 0 15.15 2.599 2.6 2.6 2.6 6.783 2.6 15.15v1.479c0 8.367 0 12.55-2.6 15.15-2.599 2.6-6.782 2.6-15.15 2.6H17.75Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.382 22.785a2.231 2.231 0 0 1-1.695-2.162V8.581a1.79 1.79 0 0 1 2.23-1.73l7.165 1.79a2.231 2.231 0 0 1 1.695 2.163v12.042a1.79 1.79 0 0 1-2.229 1.73l-7.166-1.79ZM7.898 28.33a2.231 2.231 0 0 1-1.695-2.162V14.126a1.79 1.79 0 0 1 2.229-1.73l7.166 1.79a2.231 2.231 0 0 1 1.695 2.163V28.39a1.79 1.79 0 0 1-2.229 1.73l-7.166-1.79Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.64 25.558a2.231 2.231 0 0 1-1.695-2.162V11.354a1.79 1.79 0 0 1 2.229-1.73l7.166 1.79a2.231 2.231 0 0 1 1.695 2.162V25.62a1.79 1.79 0 0 1-2.229 1.73l-7.166-1.79Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 26.733a.728.728 0 0 1-.548-.681l-.312-9.197c-.09-1.217-.993-2.185-1.938-2.47a.127.127 0 0 0-.14.051.108.108 0 0 0 .024.145c.233.18.875.77.875 1.786l-.002 9.849 2.041.517ZM26.075 23.958a.724.724 0 0 1-.548-.678l-.312-9.196c-.09-1.217-.993-2.185-1.937-2.47a.127.127 0 0 0-.141.05.108.108 0 0 0 .024.146c.234.18.875.77.875 1.785l-.002 9.853 2.041.51Z",
    fill: "#000"
  })));
};
export { SvgQrCodeLogo as ReactComponent };
export default {
  "src": "/catalog/_next/static/media/qrCodeLogo.5deb4440.svg",
  "height": 37,
  "width": 37,
  "blurWidth": 0,
  "blurHeight": 0
};